import React from 'react';

import Typography from '@material-ui/core/Typography';

import { EmailSupportLink } from './email-support-link';

import { HelpScout } from '../util/helpscout-beacon';

export const ErrorMessage = () => (
  <Typography variant="body2">
    An error has occurred. Please refresh the page and try again. <br />
    If this problem persists, either use{' '}
    <span
      role="presentation"
      className="typo-link"
      onClick={() => HelpScout.beacon.navigate('/ask/')}
    >
      our chat
    </span>
    , or contact <EmailSupportLink />.
  </Typography>
);
